import { ServiceError } from "../../../../../../../../../../../service/Shared";
import { ActionButtons, Column, ErrorBox, Modal, Row } from "../../../../../../../../../../../widget";
import { useDeleteTemplateStepModal } from "./useDeleteTemplateStepModal";

interface DeleteTemplateStepModalProps {
  show: boolean;
  closeModal: () => void;
  templateUuid?: string;
  templateStepUuid?: string;
  templateStepRowVersion: number;
}

export const DeleteTemplateStepModal = ({
  show,
  closeModal,
  templateUuid,
  templateStepUuid,
  templateStepRowVersion,
}: DeleteTemplateStepModalProps): JSX.Element => {
  const { handleDeleteTemplateStep, isHandleDeleteTemplateStepLoading, onCancel, errors } = useDeleteTemplateStepModal({
    closeModal,
    templateUuid,
    templateStepUuid,
    templateStepRowVersion,
  });

  return (
    <Modal show={show} title="Delete step?" onClose={onCancel}>
      {errors && errors.length > 0 && (
        <Row spacingV="ll">
          <Column offset={3} span={6}>
            <ErrorBox
              title="Please solve the below issues before saving"
              text={errors.map((error: ServiceError) => error.message)}
            />
          </Column>
        </Row>
      )}
      <Row spacingV="ll" justify="center">
        <Column span={10} justify="center">
          <p className="body1">
            Deleting this step will permanently remove all associated tasks and their progress from the workflow. This
            action cannot be undone.
          </p>
        </Column>
      </Row>
      <form onSubmit={(e) => handleDeleteTemplateStep(e)}>
        <Row justify="center">
          <ActionButtons onCancel={onCancel} submitButtonLabel="Yes" isLoading={isHandleDeleteTemplateStepLoading} />
        </Row>
      </form>
    </Modal>
  );
};
